import React, {useEffect} from "react";
import {CurrentTrack, SpImage} from "./DataModels";
import {CardMedia, Skeleton} from "@mui/material";

import create from "zustand";
import K4Api from "../../services/K4Api";
import {config} from "../../config";


export interface SpotifyImageProps {
    sideLength: number
}

export interface SpotifyImageStore {
    hover: boolean
    setHover: (hover: boolean) => void;
}

export const useSpotifyImageStore = create<SpotifyImageStore>((set) => ({
    hover: false,
    setHover: (hover: boolean) => set(() => {
        return {hover: hover}
    })
}))

const SpotifyImage = (props: SpotifyImageProps) => {
    const [currentTrack, setCurrentTrack] = React.useState<CurrentTrack | null>(null);

    let getNearSizeImage = (images: SpImage[], width: number) => {
        let nearSizeImage = images[0];
        images.forEach(image => {
            if (image.width > width && image.width < nearSizeImage.width) {
                nearSizeImage = image;
            }
        });
        return nearSizeImage;
    }


    useEffect(() => {
        const interval = setInterval(() => {
            K4Api.getCurrentTrack().then((track) => {
                setCurrentTrack(track);
            }).catch((error) => {
                console.error(error);
                console.error(error.response);
            })
        }, config.k4api_spotify_check_interval);
        return () => clearInterval(interval);
    }, [])

    return (
        <>
            {
                currentTrack ? (
                    <CardMedia
                        component="img"
                        className={'pixelated-image'}
                        sx={{
                            width: props.sideLength,
                            height: props.sideLength,
                        }}
                        image={getNearSizeImage(currentTrack.track.images, 50).url}
                        alt="Music cover"
                    />
                ) : (
                    <Skeleton variant="rectangular" width={props.sideLength} height={props.sideLength}/>
                )
            }
        </>
    )
}

export default SpotifyImage;